import { Pipe, PipeTransform } from '@angular/core';
import { VariableSummary } from '@mtna/variable-service-core-ts';

/**
 * Determines whether visible variables in the table are selected.
 * If `all` values should meet condition, determines if all values pass.
 * If `onlySome` values should meet condition, determines if at least 1, but not all values pass.
 */
@Pipe({
  name: 'isSelected',
})
export class IsSelectedPipe implements PipeTransform {
  transform(
    length: number | null | undefined,
    valuesToCheck: 'all' | 'onlySome',
    variables: VariableSummary[] | null | undefined,
    toggledAreSelected: boolean,
    toggledUris: { [uri: string]: boolean }
  ): boolean {
    if (!length || !variables) {
      return false;
    }

    const meetConditionCount = variables.filter((v) => !!toggledUris[v.uri] === toggledAreSelected).length;
    // if all need to meet condition, ensure the count is equal,
    // if only some should meet condition, ensure the (non-zero) count is unequal
    return valuesToCheck === 'all'
      ? meetConditionCount === variables.length
      : !!meetConditionCount && meetConditionCount !== variables.length;
  }
}
